module.exports = __webpack_public_path__ + "img/idea-bulb.d138e655.webp";